import type { Guide } from "@/types";
import { useUserStore } from "@/store/userStore";
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


// Temporary: users whose network blocks folge.app (Xfinity CyberSecure) get
// links on the folgedocs.com mirror instead. Remove once Xfinity unblocks it.
const FOLGEDOCS_USER_IDS: string[] = ['12195'];

const usesFolgeDocs = (): boolean => {
  const userId = useUserStore.getState().account?.id;
  return !!userId && FOLGEDOCS_USER_IDS.includes(String(userId));
};

export const getGuidesBaseUrl = (): string => {
  if (process.env.NODE_ENV === "development") return "http://localhost:3011/g/shared/";
  return usesFolgeDocs() ? "https://www.folgedocs.com/g/shared/" : "https://folge.app/g/shared/";
};

export const getGuidePublicUrl = (guide: Guide) => {
  return `${getGuidesBaseUrl()}${guide.slug}/${guide.publicUrl}`;
}

export const getGuideWidgetUrl = (guide: Guide) => {
  return `${getGuidesBaseUrl()}${guide.slug}?widget=1`;
}

/**
 * Get the base URL for a help center based on environment
 * @param slug - The help center slug
 * @returns The base URL for the help center
 */
export const getHelpCenterBaseUrl = (slug: string): string => {
  const IS_DEV = process.env.NODE_ENV === 'development';
  return IS_DEV 
    ? `http://${slug}.folge.test:3011`
    : `https://${slug}.${usesFolgeDocs() ? 'folgedocs.com' : 'folge.app'}`;
};

/**
 * Get the full URL for a help center with optional path
 * @param slug - The help center slug
 * @param path - Optional path to append (defaults to '/')
 * @returns The full URL for the help center
 */
export const getHelpCenterUrl = (slug: string, path: string = '/'): string => {
  const baseUrl = getHelpCenterBaseUrl(slug);
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
};